// src/services/fileCompression.js
import imageCompression from 'browser-image-compression';

/**
 * Compresses an image file in the browser before upload.
 * @param {File} imageFile - The image file to compress.
 * @param {object} options - Compression options.
 * @param {number} options.maxWidthOrHeight - The maximum width or height of the output image.
 * @param {number} options.maxSizeMB - The maximum file size in megabytes.
 * @returns {Promise<File>} The compressed file.
 */
export const compressImage = async (imageFile, options) => {
  console.log(`Original image size: ${(imageFile.size / 1024 / 1024).toFixed(2)} MB`);

  const compressionOptions = {
    maxSizeMB: options.maxSizeMB || 2,         // Default max size
    maxWidthOrHeight: options.maxWidthOrHeight || 1920, // Default max resolution
    useWebWorker: true,
  };

  try {
    const compressedFile = await imageCompression(imageFile, compressionOptions);
    console.log(`Compressed image size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);
    return compressedFile;
  } catch (error) {
    console.error("Error during image compression:", error);
    // If compression fails, you might want to return the original file or throw the error
    throw error;
  }
};